import AccountsGrid from "./AccountsGrid";

/**
 * Renders the "Account" page
 * @returns {JSX.Element}
 * @constructor
 */
const AccountsPage = () => {
    return (
        <div>
            <AccountsGrid />
        </div>
    );
}

export default AccountsPage;
